import React from 'react';

import * as styles from '../icons.css';

export default () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={60}
    viewBox="0 0 60 71"
    xmlSpace="preserve"
    focusable="false"
    fill="currentColor"
    className={styles.root}
  >
    <path
      className={[styles.stroke, styles.fill].join(' ')}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M38.957 11.869V1.771H2.5v55.742h45.729V45.675l-4.435 4.434-4.837.744.8-4.781 8.472-8.471V11.869z"
    />
    <ellipse
      className={styles.shadow}
      cx={25.915}
      cy={67.811}
      rx={13.705}
      ry={2.419}
    />
    <path
      fill="none"
      className={styles.stroke}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
      d="M48.229 11.869h-9.104V1.771zM8.953 18.146h32.823M8.953 25.315h32.823m-32.823 6.91h32.823M8.953 39.711h32.823"
    />
    <g
      fill="none"
      className={styles.stroke}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={10}
    >
      <path d="m43.794 50.109-4.837.743.8-4.78 13.54-13.541s1.181-.777 2.996 1.039c1.819 1.819 1.041 2.998 1.041 2.998l-13.54 13.541z" />
      <path d="M50.62 35.511s3.163.374 3.711 3.712" />
    </g>
  </svg>
);
